__turbopack_context__.v({
  "container": "Icon-module__Oovwuq__container",
  "icon": "Icon-module__Oovwuq__icon",
  "stroke": "Icon-module__Oovwuq__stroke",
});
